"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2458],{

/***/ 53399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
module.exports = {
    common: __webpack_require__(43607)
};


/***/ }),

/***/ 24554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


module.exports = {
    network: {
        "400": "Request date is incorrect"
    },
    signIn: {
        "404": "The email or password you entered is incorrect."
    },
    signUp: {
        "406": "An account with that email already exists."
    },
    setCustomerPasswordByPasswordResetID: {
        "401": "This password reset key is expired",
        "404": "This password reset key is invalid"
    },
    getCustomerForgotPasswordLink: {
        "404": "No account found for that email address."
    },
    purchase: __webpack_require__(87099),
    updateSubscriptionByID: __webpack_require__(87099),
    changeCustomerPassword: {
        "404": "Current password is invalid"
    },
    changeCustomerEmail: {
        "404": "Current password is invalid",
        "406": "An account with that email already exists."
    },
    removeActivationFromBlackList: {
        "404": "Activation is not deactivated"
    },
    addActivationToBlackList: {
        "404": "Activation is not deactivated"
    }
};


/***/ }),

/***/ 40540:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
const { en: errors  } = __webpack_require__(75024);
module.exports = {
    ...errors,
    header: __webpack_require__(20056),
    footer: __webpack_require__(9576),
    graphql: __webpack_require__(24554),
    common: __webpack_require__(23532),
    links: __webpack_require__(65934)
};


/***/ }),

/***/ 31668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(40540),
    de: __webpack_require__(53399)
};


/***/ }),

/***/ 15582:
/***/ (function(module) {

/* eslint-disable global-require */ 
module.exports = {};


/***/ }),

/***/ 92974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
module.exports = {
    "400": __webpack_require__(66434),
    "401": __webpack_require__(3308),
    "403": __webpack_require__(18822),
    "404": __webpack_require__(83708),
    "500": __webpack_require__(12285)
};


/***/ }),

/***/ 75024:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(92974),
    de: __webpack_require__(15582)
};


/***/ }),

/***/ 25476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B$": function() { return /* binding */ logoAlt; },
/* harmony export */   "j1": function() { return /* binding */ logoPath; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_LogoLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46096);
/* harmony import */ var _insightfulscience_smart_react_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5098);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72578);





const logoPath = "/images/snapgene/logo/logo-snapgene.svg";
const logoAlt = "SnapGene by Dotmatics";
const prerenderedLogo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    Component: _insightfulscience_atomic_react_LogoLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
    href: _routes__WEBPACK_IMPORTED_MODULE_4__/* ["default"].home.url */ .ZP.home.url,
    imgSrc: logoPath,
    alt: logoAlt,
    "data-qa-selector": "header-logo"
});
/* harmony default export */ __webpack_exports__["ZP"] = (prerenderedLogo);


/***/ }),

/***/ 5803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s$": function() { return /* binding */ exchangeIdToken; },
  "QO": function() { return /* binding */ isAuthorized; },
  "_j": function() { return /* binding */ isNotAuthorized; },
  "x4": function() { return /* binding */ login; },
  "kS": function() { return /* binding */ logout; },
  "z2": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/validation/index.js + 6 modules
var validation = __webpack_require__(89965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/apollo/index.js + 14 modules
var apollo = __webpack_require__(75469);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 15 modules
var lib = __webpack_require__(4969);
;// CONCATENATED MODULE: ./src/graphql/mutations/signIn.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation signIn($email: String!, $password: String!) {\n		signIn(email: $email, password: $password) {\n			token\n			refreshToken\n			customer {\n				customerID\n			}\n		}\n	}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var signIn = ((0,lib/* default */.ZP)(_templateObject()));
const readAuthResult = (param)=>{
    let { data  } = param;
    return data === null || data === void 0 ? void 0 : data.signIn;
};

// EXTERNAL MODULE: ./src/persistent-storage/index.js + 2 modules
var persistent_storage = __webpack_require__(11095);
;// CONCATENATED MODULE: ./src/graphql/mutations/signUp.js

function signUp_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation signUp($signUpInput: SignUpInput!) {\n		signUp(signUpInput: $signUpInput) {\n			token\n			refreshToken\n			customer {\n				customerID\n			}\n		}\n	}\n"
    ]);
    signUp_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var signUp = ((0,lib/* default */.ZP)(signUp_templateObject()));
const readRegistrationResult = (param)=>{
    let { data  } = param;
    return data === null || data === void 0 ? void 0 : data.signUp;
};
const packSignUpInput = (param)=>{
    let { firstName , lastName , company , email , password  } = param;
    return {
        signUpInput: {
            firstName,
            lastName,
            company,
            email,
            password,
            createdBy: "customer sign up"
        }
    };
};

// EXTERNAL MODULE: ./src/persistent-storage/token.js
var token = __webpack_require__(49423);
;// CONCATENATED MODULE: ./src/graphql/mutations/gqlExchangeIdToken.js

function gqlExchangeIdToken_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation gqlExchangeIdToken($issuerId: String!, $idToken: String!) {\n		exchangeToken(issuerId: $issuerId, idToken: $idToken) {\n			token\n			refreshToken\n			customer {\n				customerID\n			}\n		}\n	}\n"
    ]);
    gqlExchangeIdToken_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var gqlExchangeIdToken = ((0,lib/* default */.ZP)(gqlExchangeIdToken_templateObject()));

;// CONCATENATED MODULE: ./src/graphql/mutations/signOut.js

function signOut_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation logout($refreshToken: String!) {\n		signOut(refreshToken: $refreshToken)\n	}\n"
    ]);
    signOut_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var signOut = ((0,lib/* default */.ZP)(signOut_templateObject()));
const signOut_readAuthResult = (param)=>{
    let { data  } = param;
    return data === null || data === void 0 ? void 0 : data.signOut;
};

;// CONCATENATED MODULE: ./src/services/auth.js









const setTokens = (context)=>(param)=>{
        let { token , refreshToken  } = param;
        (0,persistent_storage/* Token */.WU)(context).set(token);
        (0,persistent_storage/* RefreshToken */.E6)(context).write(refreshToken, {
            expires: 365
        });
    };
const login = (param)=>{
    let { email , password  } = param;
    return (0,apollo/* default */.Z)().mutate({
        mutation: signIn,
        variables: {
            email,
            password
        }
    }).then(readAuthResult).then(setTokens());
};
const logout = (context)=>Promise.resolve((0,persistent_storage/* RefreshToken */.E6)(context).read()).then((refreshToken)=>refreshToken == null || (0,apollo/* default */.Z)(context).mutate({
            mutation: signOut,
            variables: {
                refreshToken
            }
        }).then((param)=>{
            let { data  } = param;
            return data;
        })).finally(()=>{
        (0,apollo/* default */.Z)(context).stop();
        (0,persistent_storage/* clearAll */.qF)(context);
        (0,apollo/* default */.Z)(context).resetStore();
    });
const register = (param)=>{
    let { firstName , lastName , company , email , password  } = param;
    return (0,apollo/* default */.Z)().mutate({
        mutation: signUp,
        variables: packSignUpInput({
            firstName,
            lastName,
            company,
            email,
            password
        })
    }).then(readRegistrationResult).then(setTokens());
};
const isAuthorized = (context)=>(0,pipe/* default */.Z)((0,persistent_storage/* Token */.WU)(context).get(), token/* isTokenValid */.D3) && (0,pipe/* default */.Z)((0,persistent_storage/* RefreshToken */.E6)(context).read(), token/* isTokenValid */.D3);
const isNotAuthorized = (0,validation/* not */.ff)(isAuthorized);
const exchangeIdToken = (context, issuerId, idToken)=>(0,apollo/* default */.Z)(context).mutate({
        mutation: gqlExchangeIdToken,
        variables: {
            issuerId,
            idToken
        }
    }).then((param)=>{
        let { data  } = param;
        return data.exchangeToken;
    }).then(setTokens(context));


/***/ }),

/***/ 43607:
/***/ (function(module) {

module.exports = JSON.parse('{"testMessage":"Test message (de)","errorWithStatus":"Auf dem Server ist ein Fehler ({{statusCode}}) aufgetreten","errorWithoutStatus":"Auf dem Server ist ein Fehler aufgetreten"}');

/***/ }),

/***/ 23532:
/***/ (function(module) {

module.exports = JSON.parse('{"testMessage":"Test message (en)","errorWithStatus":"A {{statusCode}} error occurred on server","errorWithoutStatus":"An error occurred on the server","API_ERROR_ON_PURCHASE":"Your payment was processed successfully, but we were enable to generate a SnapGene License due to temporarry error. We have escalated this to our Customer Support team, and you will be receiving a SnapGene license withing next 48 hours. Please do not submit another purchase."}');

/***/ }),

/***/ 9576:
/***/ (function(module) {

module.exports = JSON.parse('{"PRODUCT":"Product","FEATURES":"SnapGene Features","VIEWER":"SnapGene Viewer","SERVER":"SnapGene Server","CONVERT_FILE_FORMATS":"How to Convert File Formats","CRISPR":"CRISPR","WHATS_NEW":"What’s New","RELEASE_NOTES":"Release Notes","GET_PRODUCT":"Get SnapGene","FREE_TRIAL":"Free Trial","PRICING":"Pricing","COURSE_LICENSES":"Course Licenses","IGEM":"iGEM","SNAPGENE_ACADEMY":"SnapGene Academy","RESOURCES":"Resources","PRODUCT_TUTORIALS":"Product Tutorials","USER_GUIDE":"User Guide","QUESTIONS":"Common Questions","PLASMIDS":"Plasmids","CORONAVIRUS_RESOURCES":"Coronavirus Resources","CLONING_TOOLS":"Molecular Cloning Tools","RESTRICTION_CLONING":"Restriction Cloning","GIBSON_ASSEMBLY":"Gibson Assembly","INFUSION_CLONING":"In-Fusion Cloning","TA_CLONING":"TA Cloning","NEBUILDER_HIFI":"NEBuilder HiFi","GATEWAY_CLONING":"Gateway Cloning","TOPO_CLONING":"TOPO Cloning","PCR_CLONING":"PCR Cloning","GOLDEN_GATE":"Golden Gate Assembly","COMPANY":"Company","ABOUT":"About SnapGene","CUSTOMERS":"Customers","CITATIONS":"Citations","SUPPORT":"Support","DOTMATICS":"Dotmatics","PORTFOLIO":"Portfolio","CAREERS":"Careers","CONTACT":"Contact","COMPANY_NAME":"SnapGene","PRIVACY_POLICY":"Privacy Policy","LEGAL_DISCLAIMERS":"Legal Disclaimers","DO_NOT_SELL":"Do Not Sell or Share My <br /> Personal Information"}');

/***/ }),

/***/ 20056:
/***/ (function(module) {

module.exports = JSON.parse('{"FEATURES":"Features","RESOURCES":"Resources","PLASMIDS":"Plasmids","SUPPORT":"Support","CONTACT":"Contact","HOW_TO_BUY":"Pricing","SIGNIN":"Sign In","MY_ACCOUNT":"My Account","MY_LICENSES":"My Licenses","PREFERENCES":"Preferences","LOGOUT":"Sign Out","GETTING_STARTED":"Getting Started","SNAGENE_ACADEMY":"SnapGene Academy","USER_GUIDES":"User Guides","topbar":{"PLATFORM_PRODUCTS":"Explore the Scientific R&D Platform","products":{"PRISM":"Statistical analysis and graphing software for scientists","GENEIOUS":"Bioinformatics, cloning, and antibody discovery software","SNAPGENE":"Plan, visualize, & document core molecular biology procedures","LABARCHIVES":"Electronic Lab Notebook to organize, search and share data","PROTEINMETRIC":"Proteomics software for analysis of mass spec data","OMIQ":"Modern cytometry analysis platform","FCSEXPRESS":"Analysis, statistics, graphing and reporting of flow cytometry data","NQUERY":"Software to optimize designs of clinical trials","BTN":"Explore the Applications"},"platform":{"TITLE":"An open portfolio of interoperable, industry leading products","DESC":"The Dotmatics digital science platform provides the first true end-to-end solution for scientific R&D, combining an enterprise data platform with the most widely used applications for data analysis, biologics, flow cytometry, chemicals innovation, and more.","BTN":"Explore the Platform"}}}');

/***/ }),

/***/ 65934:
/***/ (function(module) {

module.exports = JSON.parse('{"TERMS":"<a href=\'{{tosLink}}\'>Terms of Service</a>","POLICY":"<a href=\'{{ppLink}}\'>Privacy Policy</a>"}');

/***/ }),

/***/ 87099:
/***/ (function(module) {

module.exports = JSON.parse('{"400":"Payment data is incorrect","declined":"The transaction was declined. Please use a different card or contact your bank.","insufficient_funds":"The transaction was declined due to insufficient funds in your account. Please use a different card or contact your bank.","temporary_hold":"Your card has a temporary hold. Please use a different card or contact your bank.","too_many_attempts":"The transaction was declined. You have exceeded a reasonable number of attempts. Please wait a while before retrying your card, or try a different card.","call_issuer":"Your transaction was declined. Please contact your bank for further details or try another card.","call_issuer_update_cardholder_data":"Please contact support: the payment system experienced an unspecified error with your card issuer.","paypal_primary_declined":"Your primary funding source was declined. Please try again or update your billing information with PayPal.","paypal_declined_use_alternate":"Your primary funding source was declined. Please try again to use your secondary funding source.","declined_security_code":"The security code you entered does not match. Please update the CVV and try again.","declined_exception":"The transaction was declined. Please try again or try another card.","declined_missing_data":"Your billing information is missing some required","invalid_data":"The transaction was declined due to invalid","invalid_email":"Your email address is not valid.","declined_card_number":"Your card number is not valid. Please update your card number.","invalid_card_number":"Your card number is not valid. Please update your card number.","invalid_account_number":"Your account number is not valid. Please update your account number.","declined_expiration_date":"Your expiration date is invalid or does not match.","gateway_token_not_found":"Your payment details were not found. Please update your billing information.","exceeds_daily_limit":"The transaction exceeds your daily approval limit. Please contact your bank or try another card.","invalid_merchant_type":"Your card is not allowed to complete this transaction. Please try another card.","invalid_transaction":"Your card is not allowed to complete this transaction. Please contact your bank or try another card.","invalid_issuer":"Your card number is not valid. Please try another card or contact your bank.","card_type_not_accepted":"Your card type is not accepted. Please try another card.","payment_not_accepted":"Your payment type is not accepted. Please try another card.","restricted_card":"Your card cannot be accepted. Please contact your issuing bank for details or try another card.","restricted_card_chargeback":"Your card cannot be accepted. Please contact your issuing bank for details or try another card.","card_not_activated":"Your card has not been activated. Please call your bank to activate your card and try again.","deposit_referenced_chargeback":"The refund cannot be processed because of a chargeback.","customer_canceled_transaction":"You canceled the transaction after it was approved. Please update your billing information to authorize a new transaction.","cardholder_requested_stop":"You requested recurring payments no longer be accepted on this card. Please update your billing information.","no_billing_information":"Your billing information is not on file. Please add your billing information.","paypal_invalid_billing_agreement":"Your PayPal billing agreement is no longer valid. Please update your billing information.","paypal_hard_decline":"Your primary funding source was declined. Please update your billing information with PayPal or try again.","paypal_account_issue":"Your primary funding source was declined. Please update your billing information with PayPal or try again.","fraud_address":"Your billing address does not match the address on your account. Please fix your address or contact your bank.","fraud_stolen_card":"The transaction was declined. Please use a different card or contact your bank.","fraud_ip_address":"The transaction was declined. Please contact support.","fraud_security_code":"The security code you entered does not match. Please update the CVV and try again.","expired_card":"Your credit card is expired, please update your card.","fraud_gateway":"The transaction was declined. Please use a different card or contact your bank.","fraud_too_many_attempts":"You attempted to use this card too many times. Please wait 15 minutes before trying again, or use a different card.","fraud_advanced_verification":"The transaction was declined. Please use a different card or contact your bank.","fraud_velocity":"The transaction was declined. Please contact support.","fraud_generic":"Please validate information and try again. If the problem persists, please contact your bank.","fraud_address_recurly":"Your billing address does not match the address on your account. Please fix your address or contact your bank.","fraud_risk_check":"Your billing address does not match the address on your account. Please fix your address or contact your bank.","fraud_manual_decision":"This transaction was declined because it appears to be a fraudulent attempt. Please try a different card.","invalid_gateway_configuration":"Please contact support: the payment system is configured incorrectly. Your card was not charged.","invalid_login":"Please contact support: the payment system is configured incorrectly. Your card was not charged.","gateway_unavailable":"Please contact support: the payment system experienced an unspecified error with your card issuer.","processor_unavailable":"Please contact support: the payment system experienced an unspecified error with your card issuer.","issuer_unavailable":"Please contact support: the payment system experienced an unspecified error with your card issuer.","gateway_timeout":"Please contact support: the payment system did not respond in time to process your transaction.","gateway_error":"An error occurred while processing your transaction. Please contact support.","contact_gateway":"Please contact support: the payment system experienced an unspecified error with your card issuer.","try_again":"The payment system would like you to please try again.","cvv_required":"Please contact support: the payment system experienced an error. Your card was not charged.","currency_not_supported":"Please contact support: the requested currency is not supported for this merchant. Your card was not charged.","ssl_error":"Please contact support: the payment system experienced an error. Your card was not charged.","zero_dollar_auth_not_supported":"Please contact support: the payment system experienced an error while authorizing your card. Your card was not charged.","no_gateway":"Please contact support: the payment system experienced an unspecified error with your card issuer.","ach_transactions_not_supported":"Please contact support: ACH/EFT transfers are not supported.","three_d_secure_not_supported":"Please contact support: the payment system experienced an error. Your card was not charged.","transaction_not_found":"The original transaction was not found.","transaction_settled":"The transaction has already been settled, so it cannot be voided. Please try a refund.","transaction_already_voided":"The transaction has already been voided, so it cannot be settled or refunded.","transaction_failed_to_settled":"The transaction did not settle successfully. Please update your billing information.","payment_cannot_void_authorization":"An error occurred while voiding your payment authorization. Please contact support.","partial_credits_not_supported":"An error occurred while refunding your transaction. Please contact support.","cannot_refund_unsettled_transactions":"An error occurred while refunding your transaction. Please contact support.","transaction_cannot_be_refunded":"The transaction cannot be refunded. Please contact support.","transaction_cannot_be_voided":"The transaction cannot be voided. Please contact support.","total_credit_exceeds_capture":"An error occurred while refunding your transaction. Please contact support.","authorization_expired":"An error occurred while processing your transaction. Please contact update your billing information.","authorization_already_captured":"An error occurred while processing your transaction. Please contact support.","authorization_amount_depleted":"An error occurred while processing your transaction. Please contact support.","recurly_error":"An error occurred while processing your transaction. Please contact support.","unknown":"The transaction was declined or failed for an unknown reason. Please try again or contact support.","api_error":"An error occurred while processing your transaction. Please contact support.","duplicate_transaction":"A similar transaction was recently submitted. Please wait a few minutes and try again.","recurly_failed_to_get_token":"An error occurred while initializing the transaction. Please try again.","recurly_token_not_found":"An error occurred while processing your transaction. Please contact support.","invalid_payment_method_hard":"Your transaction was declined. Please contact your bank for further details or try another card.","invalid_payment_method":"Your transaction was declined. Please contact your bank for further details or try another card.","amazon_declined_review":"Your card was declined. In order to resolve the issue, check your payment method in Amazon.","amount_too_small":"The specified amount is less than the minimum amount allowed. Please contact support."}');

/***/ }),

/***/ 66434:
/***/ (function(module) {

module.exports = JSON.parse('{"BAD_REQUEST":"Bad Request","DESC":"We’re sorry, you didn’t provide all mandatory inputs or provided data was incorrect.","PLEASE":"Please","CONTACT_US":"contact us","FOR_FURTHER_ASSISTANCE":"for further assistance"}');

/***/ }),

/***/ 3308:
/***/ (function(module) {

module.exports = JSON.parse('{"NOT_AUTHORIZED":"Not Authorized","DESC":"We’re sorry. You are not authorized to access the requested resource.","PLEASE":"Please","SIGN_IN":"sign in","WITH_DIFFERENT_ACCOUNT":"with a different account, or","CONTACT_US":"contact us","FOR_FURTHER_ASSISTANCE":"for further assistance"}');

/***/ }),

/***/ 18822:
/***/ (function(module) {

module.exports = JSON.parse('{"NOT_PERMITTED":"Not Permitted","DESC":"We’re sorry, you don’t have sufficient permissions to access this resource.","PLEASE":"Please","CONTACT_US":"contact us","FOR_FURTHER_ASSISTANCE":"for further assistance"}');

/***/ }),

/***/ 83708:
/***/ (function(module) {

module.exports = JSON.parse('{"NOT_FOUND":"Not Found","DESC":"We’re sorry. The requested resource was not found."}');

/***/ }),

/***/ 12285:
/***/ (function(module) {

module.exports = JSON.parse('{"SOMETHING_WENT_WRONG":"Something went wrong","DESC":"We’re sorry. Something has gone wrong with the application.","PLEASE":"Please try again later or","CONTACT_US":"contact us","FOR_FURTHER_ASSISTANCE":"for further assistance"}');

/***/ })

}]);